import { BaseNode } from "./baseNode";

export const MathNode = ({ id }) => {
  return (
    <BaseNode
      id={id}
      title="Math"
      leftHandles={[
        { id: `${id}-a`, top: '35%', label: 'Value A' },
        { id: `${id}-b`, top: '65%', label: 'Value B' },
      ]}
      rightHandles={[
        { id: `${id}-result`, top: '50%', label: 'Result' },
      ]}
    >
      <div>Add / Multiply Numbers</div>
    </BaseNode>
  );
};
